export enum Sort {
  asc = 'asc',
  desc = 'desc'
}
